// Bootstrap dependencies
require("./bootstrap");

// Extend Vue
require("./extend");

// Register Vue components
require("./components");

// Initialize Vue app
require("./init");
